export default __webpack_public_path__ + "static/media/tombergerL.9421cb17.jpg";